import { render, staticRenderFns } from "./AddWarehouse.vue?vue&type=template&id=16d861c0&scoped=true&"
import script from "./AddWarehouse.vue?vue&type=script&lang=js&"
export * from "./AddWarehouse.vue?vue&type=script&lang=js&"
import style0 from "./AddWarehouse.vue?vue&type=style&index=0&id=16d861c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d861c0",
  null
  
)

export default component.exports